export default __webpack_public_path__ + "_/images/freespins/freespins-50-bb7452ec1580d96783c4d2b66c2abedbdd1de3827bcbd29749b668d4ec3afec0.png";